import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11a67ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sr-only",
  "aria-describedby": "close modal button"
}, "Close modal", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" })
], -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = ["aria-describedby"]
const _hoisted_5 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src", "alt", "fetchpriority"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.workModalClass, { open: _ctx.isOpen, closing: _ctx.closing }])
  }, [
    _createElementVNode("button", {
      class: "close_modal_button",
      role: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
    }, _hoisted_3),
    _createElementVNode("div", {
      class: _normalizeClass(['work_modal_content', _ctx.isOpen ? 'loaded' : '']),
      "aria-describedby": `${_ctx.work?.title} overview`
    }, [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("header", null, [
              _createElementVNode("p", {
                class: _normalizeClass(["work_modal__project_type", _ctx.projectTypeClass])
              }, _toDisplayString(_ctx.projectType), 3),
              _createElementVNode("h2", null, _toDisplayString(_ctx.work?.title), 1),
              _createElementVNode("h3", null, _toDisplayString(_ctx.technologyTags.join(" ")), 1)
            ]),
            _createElementVNode("section", null, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.work?.paragraphs, (paragraph, id) => {
                  return (_openBlock(), _createElementBlock("p", { key: id }, _toDisplayString(paragraph), 1))
                }), 128)),
                _createElementVNode("p", null, [
                  _createTextVNode(" You can check this project live on: "),
                  _createElementVNode("a", {
                    href: 'https://' + _ctx.work?.live,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, _toDisplayString(_ctx.work?.live), 9, _hoisted_6)
                ]),
                (_ctx.work?.github)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _createTextVNode(" You can check the source code of this project on: "),
                      _createElementVNode("a", {
                        href: 'https://' + _ctx.work?.github,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _toDisplayString(_ctx.work?.github), 9, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.work?.pages)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.work.pages, (page, id) => {
                        return (_openBlock(), _createElementBlock("img", {
                          key: id,
                          src: require(`@/assets/images/works/${_ctx.work?.id}/${page.src}`),
                          alt: page.alt,
                          fetchpriority: id === 0 ? 'high' : 'low',
                          loading: "lazy",
                          decoding: "async"
                        }, null, 8, _hoisted_10))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_4)
  ], 2))
}